import React, { useEffect, useState } from 'react';

const TypeWriter = ({
    content = '',
    isStreaming,
    handleStreamTypingCompleted,
    speed = 10,
}) => {
    const [displayedContent, setDisplayedContent] = useState('');
    const [index, setIndex] = useState(0);

    useEffect(() => {
        let animKey;

        if (index < content.length - 1) {
            animKey = setInterval(() => {
                setIndex((prevIndex) => {
                    const nextIndex = prevIndex + 1;
                    return nextIndex;
                });
            }, speed);
        }
        return () => {
            if (!isStreaming) {
                clearInterval(animKey);
            }
            clearInterval(animKey);
        };
    }, [content, handleStreamTypingCompleted, speed, index]);

    useEffect(() => {
        setDisplayedContent((prevDisplayedContent) => {
            return prevDisplayedContent + content[index];
        });
    }, [index]);

    useEffect(() => {
        if (!isStreaming && index >= content.length - 1) {
            handleStreamTypingCompleted();
        }
    }, [index, content, isStreaming]);

    return (
        <pre style={{ whiteSpace: 'pre-wrap' }} className='typewriter'>
            {displayedContent}
        </pre>
    );
};

export default TypeWriter;
